import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

export default function ResourcesLayout({ children, data, close, white = false }) {
    const { t } = useTranslation();
    const term = data?.[0]?.term || '';
    const pageTitle = term.split(':')[0]?.trim() || '';
    const pageSubtitle = term.split(':')[1]?.trim() || '';
    const abstract = data?.[0]?.abstract ? parse(data?.[0]?.abstract) : '';

    return (
        <div className={"area-card bottom-shadow py-7" + ' ' + (white ? ' has-background-white' : 'has-background-light')}>
            <div className="wrapper">
                    <div className="columns gap-8 is-widescreen pt-0">

                        <div className="column flow--l">
                            <div className="columns is-widescreen gap-8">
                                <div className="column is-one-third-widescreen">
                                    <div className="flow--xl">
                                        <h1 className="is-uppercase has-text-weight-semibold">{pageTitle}{pageSubtitle ? <>:<br/><strong>{pageSubtitle}</strong></> : '' }</h1>
                                        <p className="has-text-weight-light is-hidden-mobile">{abstract}</p>
                                    </div>
                                </div>
                                <div className="column flow is-relative">
                                    <div className="area-card--resources has-background-white radius">
                                        <button className="close-btn" aria-label={t('Cerrar')} onClick={close}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M36 12 12 36M12 12l24 24"/></g></svg>
                                        </button>
                                        {children}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

            </div>
        </div>
    )
}